// import spotEdit from "./edit.vue";
import commodityList from "./list.vue";
let a = Object.assign({ commodityList });
export default a;
